class HomeGymMoreAppSlider extends HTMLElement {
  constructor() {
    super();

    this.BREAKPOINT = 1024;
    this.RESIZE_DEBOUNCE_MS = 150;

    this.$slick = null;
    this.resizeTimer = null;

    this.debouncedHandleResize = this.debouncedHandleResize.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.waitForSlick(() => {
      this.$slick = window.jQuery(this.querySelector('.slick'));
      if (!this.$slick.length) return;

      this.bindEvents();
      this.initSlider();

      window.addEventListener('resize', this.debouncedHandleResize);
    });
  }

  disconnectedCallback() {
    clearTimeout(this.resizeTimer);
    window.removeEventListener('resize', this.debouncedHandleResize);

    this.destroySlider();
    this._initialized = false;
  }

  bindEvents() {
    this.$slick.on('init', (e, slick) => {
      this.initTitles(slick.currentSlide);
    });

    this.$slick.on('beforeChange', (e, slick, curr, next) => {
      this.handleTitleTransition(this.isNext(slick, curr, next), next);
    });

    this.$slick.on('afterChange', (e, slick) => {
      if (typeof calculateSlickScrollPercentage === 'function') {
        calculateSlickScrollPercentage(slick);
      }
    });
  }

  waitForSlick(callback, attempts = 0) {
    if (window.jQuery?.fn?.slick) return callback();
    if (attempts >= 100) return;

    requestAnimationFrame(() => this.waitForSlick(callback, attempts + 1));
  }

  initSlider() {
    if (window.innerWidth >= this.BREAKPOINT || this.isInitialized()) return;

    this.$slick.find('.slick-item:hidden').remove();

    const dotsContainer = this.querySelector('.home-gym-more-app__dots');

    this.$slick.slick({
      centerMode: true,
      centerPadding: '60px',
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      appendDots: dotsContainer ? window.jQuery(dotsContainer) : undefined,
      infinite: true,
      arrows: false,
      variableWidth: true
    });

    this.$slick.slick('setPosition');
  }

  destroySlider() {
    if (this.isInitialized()) {
      this.$slick.slick('unslick');
    }
  }

  debouncedHandleResize() {
    clearTimeout(this.resizeTimer);

    this.resizeTimer = setTimeout(() => {
      if (window.innerWidth < this.BREAKPOINT) {
        this.initSlider();

        if (this.isInitialized()) {
          this.$slick.slick('setPosition');
        }

        return;
      }

      this.destroySlider();
    }, this.RESIZE_DEBOUNCE_MS);
  }

  initTitles(index) {
    this.captions.forEach(title => {
      const isActive = Number(title.dataset.index) === index;

      title.classList.remove('next', 'prev', 'active', 'hidden');
      title.classList.add(isActive ? 'active' : 'hidden');
    });
  }

  handleTitleTransition(direction, nextIndex) {
    const activeTitle = this.querySelector(
      '.home-gym-more-app__caption.active'
    );
    const nextTitle = this.querySelector(
      `.home-gym-more-app__caption[data-index="${nextIndex}"]`
    );

    if (!activeTitle || !nextTitle) {
      this.initTitles(nextIndex);
      return;
    }

    if (Number(activeTitle.dataset.index) === nextIndex) return;

    const addedClass = direction ? 'next' : 'prev';
    const removedClass = direction ? 'prev' : 'next';

    this.hideTitle(activeTitle, removedClass);
    this.showTitle(nextTitle, addedClass);
  }

  hideTitle(title, className) {
    title.dispatchEvent(new CustomEvent('transitionend'));
    title.classList.add(className);
    title.classList.remove('active');

    this.afterTransition(title, () => {
      title.classList.add('hidden');
      title.classList.remove(className);
    });
  }

  showTitle(title, className) {
    title.dispatchEvent(new CustomEvent('transitionend'));
    title.classList.add(className);
    title.classList.remove('hidden');

    setTimeout(() => {
      title.classList.add('active');
    }, 10);

    this.afterTransition(title, () => {
      title.classList.remove(className);
    });
  }

  afterTransition(title, callback) {
    if (window.innerWidth >= 1280) {
      callback();
      return;
    }

    title.addEventListener('transitionend', callback, { once: true });
  }

  isNext(slick, curr, next) {
    return next === 0 && curr === slick.slideCount - 1 ? true : next > curr;
  }

  isInitialized() {
    return this.$slick?.hasClass('slick-initialized');
  }

  get captions() {
    return this.querySelectorAll('.home-gym-more-app__caption');
  }
}

if (!customElements.get('home-gym-more-app-slider')) {
  customElements.define('home-gym-more-app-slider', HomeGymMoreAppSlider);
}
